export default "__VITE_ASSET__BfrcG54Y__"